import { css } from "@emotion/react";

export const imageStyles = css`
  .ReactCrop__image {
    max-height: 31.25rem;
  }
`;
